import axios from 'axios';
import CookieHandler from '../pages/LandingPage/Authentication/CookieHandler'

async function PostRequest(path = '', data, isAuthenticated) {
  let headers = {
    'Content-Type': 'application/json'
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('API URL:', apiUrl);

  if (isAuthenticated) {
    const token = CookieHandler.getCookie('token');
    headers['Authorization'] = `Bearer ${token}`;
  }
  console.log(process.env);

  try {
    const response = await axios.post(
      apiUrl + '/api/' + path,
      data,
      { headers }
    );

    if (response.status === 200 || response.status === 201) {
      return { data: response.data, status: response.status };
    } else if (response.status === 204) {
      return { data: null, status: response.status };
    } else if (response.status === 401) {
      throw new Error(response.data.message || 'User not found. Kindly register with us.');
    } else if (response.status === 403) {
      throw new Error(response.data.message || 'Username or Password wrong.');
    } else {
      throw new Error(response.data.message || 'Server returned an error. Please try again later.');
    }
  } catch (error) {
    console.error('Error in postData:', error);
    throw new Error(error.response?.data?.message || 'An error occurred. Please try again later.');
  }
}

export default PostRequest;
